module.exports = __webpack_public_path__ + "img/stickerrounded.620f10ca.webp";